import { render, staticRenderFns } from "./RunningHoursOldDetail.vue?vue&type=template&id=059b3695"
import script from "./RunningHoursOldDetail.vue?vue&type=script&lang=js"
export * from "./RunningHoursOldDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports